<template>
  <button
    type="button"
    class="button"
    :class="buttonClasses"
    :disabled="props.disabled || props.loading"
    @click="handleClick"
  >
    <BaseSvg
      v-if="props.leftIcon && !props.loading"
      class="left-icon icon"
      :src="props.leftIcon"
      alt="left-icon"
    />
    <span v-if="props.loading" class="loader" />
    <span v-if="!slots.default && !!props.text">
      {{ props.text }}
    </span>
    <span v-if="!props.loading && !!slots.default">
      <slot />
    </span>
    <BaseSvg
      v-if="props.rightIcon && !props.loading"
      class="right-icon icon"
      :src="props.rightIcon"
      alt="right-icon"
    />
  </button>
</template>

<script lang="ts" setup>
import { useSlots, computed } from "vue";
import BaseSvg from "./BaseSvg.vue";

export type ButtonSize = "small" | "medium" | "large";
export type ButtonVariant = "neutral" | "primary" | "secondary" | "danger";

export interface IButton {
  size?: ButtonSize;
  variant?: ButtonVariant;
  bordered?: boolean;
  rounded?: boolean;
  ghost?: boolean;
  text?: string;
  disabled?: boolean;
  fluid?: boolean;
  rightIcon?: string;
  leftIcon?: string;
  loading?: boolean;
  isMobile?: boolean;
}

const props = withDefaults(defineProps<IButton>(), {
  size: "medium",
  variant: "primary",
  text: "Button",
  disabled: false,
  fluid: false,
  loading: false,
  isMobile: false,
  bordered: false,
  rounded: false,
  ghost: false,
});

const emit = defineEmits(["onClick"]);

const buttonClasses = computed(() => {
  return {
    fluid: props.isMobile || props.fluid,
    bordered: props.bordered,
    rounded: props.rounded,
    ghost: props.ghost,
    [props.size]: props.isMobile ? "large" : props.size,
    [props.variant]: props.variant,
  };
});

const slots = useSlots();
const handleClick = () => {
  emit("onClick");
};
</script>

<style lang="scss" scoped src="./styles/button.scss" />
